import React, { useEffect, useState } from "react";
import Modal from "@amzn/meridian/modal";
import Text from "@amzn/meridian/text";
import Link from "@amzn/meridian/link";
import Column from "@amzn/meridian/column";

const DEFAULT_TEAM_LINK = "https://permissions.amazon.com/a/team/eagleeye-access-team-1";

// Global state so the error persists even if modal hasn't mounted yet
let pendingAuthError: { teamLink: string; errorType: string } | null = null;

export const dispatchAuthError = (teamLink: string, errorType: string) => {
  pendingAuthError = { teamLink: teamLink || DEFAULT_TEAM_LINK, errorType };
  window.dispatchEvent(new Event("eagleeye-auth-error"));
};

export const AuthErrorModal = () => {
  const [open, setOpen] = useState(false);
  const [teamLink, setTeamLink] = useState(DEFAULT_TEAM_LINK);
  const [errorType, setErrorType] = useState("");

  useEffect(() => {
    const handler = () => {
      if (pendingAuthError) {
        setTeamLink(pendingAuthError.teamLink);
        setErrorType(pendingAuthError.errorType);
        setOpen(true);
        pendingAuthError = null;
      }
    };
    if (pendingAuthError) {
      handler();
    }
    window.addEventListener("eagleeye-auth-error", handler);
    return () => window.removeEventListener("eagleeye-auth-error", handler);
  }, []);

  const isManagerAuth = errorType === "HELIS_AUTH";

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      scrollContainer="viewport"
      closeLabel="Close"
    >
      <Column spacing="small">
        <Text type="h300" color="error">
          {isManagerAuth
            ? "You don't have access to EagleEye. Please contact your manager. The EagleEye team cannot grant permissions."
            : "You don't have access to this feature."}
        </Text>
        <Text tag="h4">Here are the steps:</Text>
        {isManagerAuth ? (
          <>
            <Text>
              <strong>Step 1:</strong> Your manager needs to add you to{" "}
              <Link href={teamLink} target="_blank">{teamLink}</Link>
            </Text>
            <Text>
              <strong>Step 2:</strong> Once you are added, wait for 6 hours and refresh this page.
            </Text>
            <Text type="b200" color="secondary">
              Note: Access can only be granted by your manager. Please contact them directly with the link above.
            </Text>
          </>
        ) : (
          <>
            <Text>
              <strong>Step 1:</strong> Reach out to the team owner of{" "}
              <Link href={teamLink} target="_blank">{teamLink}</Link>{" "}
              to get access.
            </Text>
            <Text>
              <strong>Step 2:</strong> Once you are added, wait for 6 hours and refresh this page.
            </Text>
            <Text type="b200" color="secondary">
              Note: Access can only be granted by the team owner. Please contact them directly with the link above.
            </Text>
          </>
        )}
      </Column>
    </Modal>
  );
};
